import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FormSelect, FormNumberInput, FormSelectValueType, FormInput } from '../Common/AwpFormInputs';
import { useSelector } from 'react-redux';
import { selectObservationTypes as selectObservationTypesDdlb } from '@stores/dropdownsSlice';
import { selectObservationTypes } from '@awp/stores/dataVisualizationSlice';
import PropTypes from 'prop-types';
import { AllOperators, OperatorsForNumber, OperatorsForNonNumber } from '@awp/constants';

const AlertCondition = ({ groupName, conditionName, onDeleteCondition, values, setFieldValue, props }) => {
  const observationTypes = useSelector(selectObservationTypes);
  const observationTypesDdlb = useSelector(selectObservationTypesDdlb);
  const obsTypeField = `TriggerGroup.observationType_${groupName}_${conditionName}`;
  const operatorField = `TriggerGroup.operator_${groupName}_${conditionName}`;
  const valueField = `TriggerGroup.value_${groupName}_${conditionName}`;
  const dataTypeField = `TriggerGroup.dataType_${groupName}_${conditionName}`;

  const getObservationType = (obsTypeSelected) => {
    if (!obsTypeSelected) {
      return null;
    }
    const observationType = observationTypes.find((x) => x.ObservationTypeId === obsTypeSelected.value);
    return observationType;
  };

  const [observationType, setObservationType] = useState(
    getObservationType(values?.TriggerGroup[`observationType_${groupName}_${conditionName}`]),
  );

  const handleDelete = (event, conditionName) => {
    onDeleteCondition(conditionName);
  };

  const handleObsTypeChange = (obsTypeSelected) => {
    const observationType = getObservationType(obsTypeSelected);
    if (observationType?.MeaningFullList) {
      setFieldValue(
        operatorField,
        AllOperators.find((x) => x.value === '='),
      );
    }

    if (
      observationType?.DataType === 'Numeric' &&
      (values?.TriggerGroup[`operator_${groupName}_${conditionName}`]?.value === 'match' ||
        values?.TriggerGroup[`operator_${groupName}_${conditionName}`] === 'match')
    ) {
      setFieldValue(operatorField, '');
    }

    setObservationType(observationType);
    setFieldValue(valueField, '');
    setFieldValue(dataTypeField, observationType?.DataType);
  };

  const getValueOptions = (meaningFullList) => {
    const options = meaningFullList.map((x) => ({ value: x.OBSERVED_CHARACTER_VALUE, label: x.DISPLAYED_MEANING }));
    return options;
  };

  const getOperators = (observationType) => {
    return observationType?.DataType == 'Numeric' ? OperatorsForNumber : OperatorsForNonNumber;
  };

  return (
    <>
      <Row className="mt-2">
        <Col sm={5}>
          <FormSelect
            readOnly={false}
            name={obsTypeField}
            label="Observation Type"
            options={observationTypesDdlb.options}
            isMulti={false}
            postChange={handleObsTypeChange}
          />
        </Col>
        <Col sm={2}>
          <FormSelect
            readOnly={false}
            name={operatorField}
            label="Operator"
            options={getOperators(observationType)}
            isMulti={false}
          />
        </Col>
        <Col sm={4}>
          {values?.TriggerGroup[`operator_${groupName}_${conditionName}`]?.value === 'match' ? (
            <FormInput label="Value" readOnly={false} name={valueField} maxLength={256} />
          ) : observationType?.MeaningFullList ? (
            <FormSelectValueType
              readOnly={false}
              id={valueField}
              label="Value"
              options={getValueOptions(observationType?.MeaningFullList)}
              isMulti={false}
              props={props}
            />
          ) : observationType?.DataType === 'Numeric' ? (
            <FormNumberInput
              readOnly={false}
              label="Value"
              name={valueField}
              isAllowed={(values) => {
                const { value } = values;
                return (value ?? '').toString().length <= 20;
              }}
            />
          ) : (
            <FormInput label="Value" readOnly={false} name={valueField} maxLength={256} />
          )}
        </Col>
        <Col sm={1} className="mt-5">
          <i
            className="fas fa-trash mx-1 my-1 awp-img-btn"
            title="Delete"
            onClick={(event) => handleDelete(event, conditionName)}
          ></i>
        </Col>
      </Row>
    </>
  );
};

AlertCondition.propTypes = {
  groupName: PropTypes.string,
  conditionName: PropTypes.string,
  onDeleteCondition: PropTypes.func,
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
  props: PropTypes.object,
};

export default AlertCondition;
